import FmdBadRoundedIcon from '@mui/icons-material/FmdBadRounded';
import { Box, Tooltip } from '@mui/material';
import React from 'react';
import SAVGuidanceIcon from '../../svg-icons/SAVGuidanceIcon';
import SAVSAVIcon from '../../svg-icons/SAVSAVIcon';
import SCOAdministrativeIcon from '../../svg-icons/SCOAdministrativeIcon';
import SCOPaymentIcon from '../../svg-icons/SCOPaymentIcon';
import SCORetractionIcon from '../../svg-icons/SCORetractionIcon';
import SCOTechnicalIcon from '../../svg-icons/SCOTechnicalIcon';
import SLOOrderIcon from '../../svg-icons/SLOOrderIcon';
import SLOShippingInformationIcon from '../../svg-icons/SLOShippingInformationIcon';
import SLOShippingProblemIcon from '../../svg-icons/SLOShippingProblemIcon';
import ErrorBoundary from '../errors/ErrorBoundary';
import InternalServerError from '../errors/InternalServerError.jsx';

const selectIconBasedOnTicketType = (ticketType) => {
  switch (ticketType) {
    case 'Technique':
      return <SCOTechnicalIcon />;
    case 'Administratif':
      return <SCOAdministrativeIcon />;
    case 'Paiement':
      return <SCOPaymentIcon />;
    case 'Rétractation':
      return <SCORetractionIcon />;
    case 'Commande':
      return <SLOOrderIcon />;
    case 'Info. Livraison':
      return <SLOShippingInformationIcon />;
    case 'Pb. Livraison':
      return <SLOShippingProblemIcon />;
    case 'Conseil':
      return <SAVGuidanceIcon />;
    case 'SAV':
      return <SAVSAVIcon />;
    default:
      return <FmdBadRoundedIcon />;
  }
};

const TicketTypeIcon = (props) => {
  const { ticketType, service } = props;

  return (
    <ErrorBoundary fallback={<InternalServerError />} source="TicketTypeIcon">
      <Tooltip placement="top" title={`${service} - ${ticketType}`}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
          {ticketType ? selectIconBasedOnTicketType(ticketType) : null}
        </Box>
      </Tooltip>
    </ErrorBoundary>
  );
};

export default TicketTypeIcon;
